import SiteLayout from '@/components/feature/SiteLayout';
import HeroCarousel from './components/HeroCarousel';
import QuickEntries from './components/QuickEntries';
import FeaturedMovies from './components/FeaturedMovies';
import ReviewsSection from './components/ReviewsSection';
import SpecialsSection from './components/SpecialsSection';
import SiteIntro from './components/SiteIntro';

export default function Home() {
  return (
    <SiteLayout>
      <HeroCarousel />
      <QuickEntries />
      <FeaturedMovies />
      <ReviewsSection />
      <SpecialsSection />
      <SiteIntro />
    </SiteLayout>
  );
}